import React, { SVGProps } from 'react';

import Plus from './assets/plus.svg?react';
import Clock from './assets/clock.svg?react';
import Clock2 from './assets/clock2.svg?react';
import Eye from './assets/eye.svg?react';
import CaretDown from './assets/caretDown.svg?react';
import ChevronDown from './assets/chevronDown.svg?react';
import Cog from './assets/cog.svg?react';
import CogActive from './assets/cogActive.svg?react';
import Documentation from './assets/documentation.svg?react';
import Settings from './assets/settings.svg?react';
import ToggleSidebar from './assets/toggleSidebar.svg?react';
import Search from './assets/search.svg?react';
import Arrow from './assets/arrow.svg?react';
import StatusRunning from './assets/statusRunning.svg?react';
import StatusOffline from './assets/statusOffline.svg?react';
import StatusUnavailable from './assets/statusUnavailable.svg?react';
import StatusRunningLight from './assets/statusRunningLight.svg?react';
import StatusOfflineLight from './assets/statusOfflineLight.svg?react';
import StatusUnavailableLight from './assets/statusUnavailableLight.svg?react';
import ArrowRight from './assets/arrowRight.svg?react';
import ArrowRightLine from './assets/arrowRightLine.svg?react';
import ArrowUp from './assets/arrowUp.svg?react';
import ArrowDown from './assets/arrowDown.svg?react';
import Timer from './assets/timer.svg?react';
import VSCode from './assets/ideIcons/vscode.svg?react';
import Cursor from './assets/ideIcons/cursor.svg?react';
import Windsurf from './assets/ideIcons/windsurf.svg?react';
import WebStorm from './assets/ideIcons/webstorm.svg?react';
import PyCharm from './assets/ideIcons/pycharm.svg?react';
import Idea from './assets/ideIcons/idea.svg?react';
import WebStormNew from './assets/ideIcons/webstormNew.svg?react';
import PyCharmNew from './assets/ideIcons/pycharmNew.svg?react';
import IdeaNew from './assets/ideIcons/ideaNew.svg?react';
import JetBrains from './assets/ideIcons/jetbrains.svg?react';
import Explore from './assets/explore.svg?react';
import ExploreActive from './assets/exploreActive.svg?react';
import LiveCode from './assets/liveCode.svg?react';
import LiveCodeActive from './assets/liveCodeActive.svg?react';
import Home from './assets/home.svg?react';
import HomeActive from './assets/homeActive.svg?react';
import Services from './assets/services.svg?react';
import ServicesBlank from './assets/servicesBlank.svg?react';
import Sun from './assets/sun.svg?react';
import Copy from './assets/copy.svg?react';
import CopyAlt from './assets/copy_alt.svg?react';
import Export from './assets/export.svg?react';
import Copied from './assets/copied.svg?react';
import Check from './assets/check.svg?react';
import CircledLeanCheck from './assets/circledLeanCheck.svg?react';
import Close from './assets/close.svg?react';
import Filters from './assets/filters.svg?react';
import LightYellow from './assets/lightYellow.svg?react';
import LightTurquoise from './assets/lightTurquoise.svg?react';
import LightBlue from './assets/lightBlue.svg?react';
import LightPurple from './assets/lightPurple.svg?react';
import LightOrange from './assets/lightOrange.svg?react';
import Logout from './assets/logout.svg?react';
import Delta from './assets/delta.svg?react';
import DirectLink from './assets/directLink.svg?react';
import Dot from './assets/dot.svg?react';
import HorizontalDots from './assets/horizontalDots.svg?react';
import PlusDot from './assets/plusDot.svg?react';
import Spinner from './assets/spinner.svg?react';
import CodeBrackets from './assets/codeBrackets.svg?react';
import CodeBracketsBold from './assets/codeBrackets_bold.svg?react';
import CodeBracketsHeadsUp from './assets/codeBracketsHeadsUp.svg?react';
import RuleBadge from './assets/ruleBadge.svg?react';
import Change from './assets/change.svg?react';
import TrafficCone from './assets/trafficCone.svg?react';
import ListCollapsed from './assets/list-collapsed.svg?react';
import ListExpanded from './assets/list-expanded.svg?react';
import Flame from './assets/flame.svg?react';
import HeadsUp from './assets/HeadsUp.svg?react';
import HeadsUpActive from './assets/HeadsUpActive.svg?react';
import SuccessNotification from './assets/successNotification.svg?react';
import ErrorNotification from './assets/errorNotification.svg?react';
import Bell from './assets/bell.svg?react';
import BellDisabled from './assets/bellDisabled.svg?react';
import Ekg from './assets/ekg.svg?react';
import EkgDisabled from './assets/ekgDisabled.svg?react';
import Star from './assets/star.svg?react';
import StarActive from './assets/starActive.svg?react';
import RightArrow from './assets/rightArrow.svg?react';
import Key from './assets/key.svg?react';
import StopWatch from './assets/stopWatch.svg?react';
import NumberedList from './assets/numberedList.svg?react';
import Plug from './assets/plug.svg?react';

import Python from './assets/languageIcons/python.svg?react';
import NodeJS from './assets/languageIcons/nodejs.svg?react';
import Java from './assets/languageIcons/java.svg?react';
import Dotnet from './assets/languageIcons/dotnet.svg?react';

import Gift from './assets/gift.svg?react';
import Monitor from './assets/monitor.svg?react';
import MCP from './assets/mcp.svg?react';
import Rocket from './assets/rocket.svg?react';
import User from './assets/user.svg?react';
import Users from './assets/users.svg?react';
import PRs from './assets/pr.svg?react';

import Flow from './assets/flow.svg?react';
import Chart from './assets/chart.svg?react';
import Endpoint from './assets/endpoint.svg?react';
import KafkaTopic from './assets/kafkaTopic.svg?react';
import MessageQueue from './assets/messageQueue.svg?react';
import Info from './assets/info.svg?react';
import Info2 from './assets/info2.svg?react';
import CircleHelp from './assets/circle-help.svg?react';
import Increase from './assets/increase.svg?react';

import GTE from './assets/gte.svg?react';
import LTE from './assets/lte.svg?react';

import Postgres from './assets/postgres.svg?react';
import Axios from './assets/axios.svg?react';
import TypeORM from './assets/typeorm.svg?react';
import DynamoDB from './assets/dynamoDB.svg?react';

import Hud from './assets/hud.svg?react';

import { getByPath } from '../utils';

// Design System Icons. Use only these (add if missing)
import AndGate from './designSystem/AndGate.svg?react';
import ArrowUpRight from './designSystem/ArrowUpRight.svg?react';
import ArrowUpRightSmall from './designSystem/ArrowUpRight_Small.svg?react';
import ArrowDownRight from './designSystem/ArrowDownRight.svg?react';
import ArrowDownRightSmall from './designSystem/ArrowDownRightSmall.svg?react';
import BellIcon from './designSystem/Bell.svg?react';
import Book from './designSystem/Book.svg?react';
import ChevronDownIcon from './designSystem/ChevronDown.svg?react';
import ChevronLeft from './designSystem/ChevronLeft.svg?react';
import ChevronLeftDouble from './designSystem/ChevronLeftDouble.svg?react';
import ChevronRight from './designSystem/ChevronRight.svg?react';
import ChevronUp from './designSystem/ChevronUp.svg?react';
import ChevronRightDouble from './designSystem/ChveronRightDouble.svg?react';
import CogIcon from './designSystem/Cog.svg?react';
import Comparison from './designSystem/Comparison.svg?react';
import Compass from './designSystem/Compass.svg?react';
import EndpointIcon from './designSystem/Endpoint.svg?react';
import FlameIcon from './designSystem/Flame.svg?react';
import FunctionIcon from './designSystem/Function.svg?react';
import Queue from './designSystem/Queue.svg?react';
import ServiceIcon from './designSystem/Service.svg?react';
import Telescope from './designSystem/Telescope.svg?react';
import ExclamationSquare from './designSystem/ExclamationSquare.svg?react';
import StatUp from './designSystem/StatUp.svg?react';
import GitMerge from './designSystem/GitMerge.svg?react';
import Hourglass from './designSystem/Hourglass.svg?react';
import Shield from './designSystem/Shield.svg?react';
import StarOutline from './designSystem/StarOutline.svg?react';
import CopyIcon from './designSystem/Copy.svg?react';
import CheckIcon from './designSystem/Check.svg?react';
import InfoCircle from './designSystem/InfoCircle.svg?react';
import Add from './designSystem/Add.svg?react';
import WarningTriangle from './designSystem/warningTriangle.svg?react';
import WarningTriangleSolid from './designSystem/warningTriangleSolid.svg?react';
import ThreeDots from './designSystem/ThreeDots.svg?react';
import XMark from './designSystem/XMark.svg?react';
import DSPlug from './designSystem/plug.svg?react';
import Sliders from './designSystem/Sliders.svg?react';
import MCP_ds from './designSystem/MCP.svg?react';
import Rocket_ds from './designSystem/Rocket.svg?react';
import Slack from './designSystem/Slack.svg?react';
import Pencil from './designSystem/Pencil.svg?react';
import Hashtag from './designSystem/Hashtag.svg?react';

export const HudIconComponents = {
  menu: {
    hud: Hud,
    plus: Plus,
    caretDown: CaretDown,
    chevronDown: ChevronDown,
    cog: Cog,
    cogActive: CogActive,
    documentation: Documentation,
    ToggleSidebar,
    explore: Explore,
    exploreActive: ExploreActive,
    liveCode: LiveCode,
    liveCodeActive: LiveCodeActive,
    home: Home,
    homeActive: HomeActive,
    services: Services,
    headsUp: HeadsUp,
    headsUpActive: HeadsUpActive,
    horizontalDots: HorizontalDots,
    logout: Logout,
  },
  languages: {
    python: Python,
    nodejs: NodeJS,
    java: Java,
    dotnet: Dotnet,
  },
  webviewMenu: {
    flow: Flow,
    chart: Chart,
    endpoint: Endpoint,
    info: Info,
  },
  entities: {
    kafkaTopic: KafkaTopic,
    messageQueue: MessageQueue,
    servicesBlank: ServicesBlank,
  },
  designSystem: {
    andGate: AndGate,
    arrowUpRight: ArrowUpRight,
    arrowUpRightSmall: ArrowUpRightSmall,
    bell: BellIcon,
    book: Book,
    chevronDown: ChevronDownIcon,
    chevronLeft: ChevronLeft,
    chevronLeftDouble: ChevronLeftDouble,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    chevronRightDouble: ChevronRightDouble,
    cog: CogIcon,
    comparison: Comparison,
    compass: Compass,
    endpoint: EndpointIcon,
    flame: FlameIcon,
    function: FunctionIcon,
    queue: Queue,
    service: ServiceIcon,
    telescope: Telescope,
    hourglass: Hourglass,
    exclamationSquare: ExclamationSquare,
    statUp: StatUp,
    gitMerge: GitMerge,
    shield: Shield,
    starOutline: StarOutline,
    copy: CopyIcon,
    check: CheckIcon,
    infoCircle: InfoCircle,
    warningTriangle: WarningTriangle,
    warningTriangleSolid: WarningTriangleSolid,
    add: Add,
    threeDots: ThreeDots,
    xmark: XMark,
    plug: DSPlug,
    arrowDownRight: ArrowDownRight,
    arrowDownRightSmall: ArrowDownRightSmall,
    sliders: Sliders,
    mcp: MCP_ds,
    rocket: Rocket_ds,
    slack: Slack,
    pencil: Pencil,
    hashtag: Hashtag,
  },
  other: {
    spinner: Spinner,
    clock: Clock,
    clock2: Clock2,
    eye: Eye,
    search: Search,
    arrow: Arrow,
    rightArrow: RightArrow,
    arrowRight: ArrowRight,
    arrowRightLine: ArrowRightLine,
    timer: Timer,
    sun: Sun,
    copy: Copy,
    copyAlt: CopyAlt,
    export: Export,
    copied: Copied,
    check: Check,
    circledLeanCheck: CircledLeanCheck,
    close: Close,
    filters: Filters,
    plug: Plug,
    delta: Delta,
    directLink: DirectLink,
    dot: Dot,
    plusDot: PlusDot,
    codeBrackets: CodeBrackets,
    codeBracketsBold: CodeBracketsBold,
    codeBracketsHeadsUp: CodeBracketsHeadsUp,
    ruleBadge: RuleBadge,
    change: Change,
    trafficCone: TrafficCone,
    listCollapsed: ListCollapsed,
    listExpanded: ListExpanded,
    flame: Flame,
    increase: Increase,
    successNotification: SuccessNotification,
    errorNotification: ErrorNotification,
    bell: Bell,
    bellDisabled: BellDisabled,
    ekg: Ekg,
    ekgDisabled: EkgDisabled,
    settings: Settings,
    star: Star,
    starActive: StarActive,
    key: Key,
    info: Info2,
    circleHelp: CircleHelp,
    gift: Gift,
    monitor: Monitor,
    mcp: MCP,
    rocket: Rocket,
    user: User,
    users: Users,
    prs: PRs,
  },
  metrics: {
    stopWatch: StopWatch,
    numberedList: NumberedList,
  },
  ides: {
    vscode: VSCode,
    cursor: Cursor,
    windsurf: Windsurf,
    idea: Idea,
    webstorm: WebStorm,
    pycharm: PyCharm,
    jetbrains: JetBrains,
    webstormNew: WebStormNew,
    pycharmNew: PyCharmNew,
    ideaNew: IdeaNew,
  },
  trends: {
    arrowUp: ArrowUp,
    arrowDown: ArrowDown,
  },
  status: {
    running: StatusRunning,
    offline: StatusOffline,
    unavailable: StatusUnavailable,
    runningLight: StatusRunningLight,
    offlineLight: StatusOfflineLight,
    unavailableLight: StatusUnavailableLight,
  },
  lights: {
    yellow: LightYellow,
    turquoise: LightTurquoise,
    blue: LightBlue,
    purple: LightPurple,
    orange: LightOrange,
  },
  comparison: {
    gte: GTE,
    lte: LTE,
  },
  thirdParty: {
    postgres: Postgres,
    axios: Axios,
    typeorm: TypeORM,
    dynamoDB: DynamoDB,
  },
};

export type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType &
    (string | number)]: ObjectType[Key] extends React.FunctionComponent
    ? `${Key}`
    : ObjectType[Key] extends object
      ? `${Key}.${NestedKeyOf<ObjectType[Key]>}`
      : `${Key}`;
}[keyof ObjectType & (string | number)];

export type IconType = NestedKeyOf<typeof HudIconComponents>;

export interface HudIconProps extends SVGProps<SVGSVGElement> {
  icon: IconType;
  size?: string;

  width?: string;
  height?: string;
}

export function HudIcon({ icon, size = '14px', width, height, ...rest }: HudIconProps) {
  const SelectedIcon = getByPath(HudIconComponents, icon);

  width = width || size;
  height = height || size;

  return (
    <SelectedIcon
      aria-label={icon}
      style={{ width, minWidth: width, height, verticalAlign: 'middle' }}
      {...rest}
    />
  );
}
